<template>
  <Card :class="$style.position">
    <img
      :class="$style.icon"
      :src="addAppleAppCard.icon"
      svg-inline
    >
    <h4 :class="$style.title">
      {{ addAppleAppCard.title }}
    </h4>
    <FlatActionButton
      :action="handleMainAction"
      :class="$style.appleBtn"
      :text="addAppleAppCard.link.text"
    />
    <p
      :class="$style.appleText"
    >
      <MarkdownInline
        :mdTemplate="addAppleAppCard.mainText"
      />
    </p>
  </Card>
</template>

<script>
import { MarkdownInline } from '@jumpcloud/ui-components';
import { MdmTabsIndex } from 'client/util/Constants';
import Card from 'client/components/Card.vue';
import FlatActionButton from 'client/components/Buttons/FlatActionButton.vue';
import Util from 'client/util/Util';

export default {
  name: 'WayToAddAppleAppCard',

  components: {
    Card,
    FlatActionButton,
    MarkdownInline,
  },

  props: {
    addAppleAppCard: {
      default: null,
      type: Object,
    },
  },

  methods: {
    handleAddCustomApp() {
      Util.redirect(this.addAppleAppCard.link.redirectUrl);
    },

    handleAddToken() {
      const params = JSON.stringify({
        selectedTab: MdmTabsIndex.vpp,
        openTokenForm: true,
      });
      Util.redirect(`?params=${encodeURIComponent(params)}${this.addAppleAppCard.link.redirectUrl}`);
    },

    handleMainAction() {
      if (this.addAppleAppCard.id === 'addToken') {
        this.handleAddToken();
      }

      if (this.addAppleAppCard.id === 'addCustomApp') {
        this.handleAddCustomApp();
      }
    },
  },
};
</script>

<style module>
@import './waysToAddAppleAppCards.css';

.position .appleBtn {
  margin-bottom: 20px;
}

.appleText {
  font-size: 12px;
}

.appleText.appleText a {
  display: unset;
}
</style>
